module.exports = __webpack_public_path__ + "static/media/learning-and-reacting-portfolio.9b38024a.md";